import { render, staticRenderFns } from "./CaseCommentAttachmentComposer.vue?vue&type=template&id=3107c74b&scoped=true&"
import script from "./CaseCommentAttachmentComposer.vue?vue&type=script&lang=js&"
export * from "./CaseCommentAttachmentComposer.vue?vue&type=script&lang=js&"
import style0 from "./CaseCommentAttachmentComposer.vue?vue&type=style&index=0&id=3107c74b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107c74b",
  null
  
)

export default component.exports